export const image = (theme) => ({
    img: {
        width: 32,
        height: 32,
    },
});
